import React from "react";
import { Link } from "react-router-dom";
import { List, FilterForm, Datagrid } from "components/list";
import FlatButton from "material-ui/FlatButton/index";
import ContentCreate from "material-ui/svg-icons/content/create";
import { TextInput, DateInput } from "components/input";
import { TextField, ChoiceDisplayField } from "components/field";
import { SelectInput } from "components/input";
import {
  DualScreenAdTypeChoices, 
  DualScreenAdTypeMap,
  DualScreenAdStatusMap, 
  DualScreenAdTargetUsersMap,
  DualScreenAdResourceName
} from "./utils";
import linkToRecordByReplaceId from "util/linkToRecordByReplaceId";
import { dualScreenAdEditFrontendPath, dualScreenAdDetailFrontendPath } from "./urls";
import connect from "react-redux/es/connect/connect";

export const ListFilter = (props) => (
  <FilterForm name="dual_screen_ad_search" {...props} initialValues={ props.defaultSearchValue }>
    <DateInput label="Create From" source="create_time_start" />
    <DateInput label="Create To" source="create_time_end" />
    <TextInput label="Name" source="ad_name" />
    <SelectInput
      source='ad_type'
      label='Ad Type'
      choices={DualScreenAdTypeChoices}
      allowEmpty={true}
    />
  </FilterForm>
);


function EditButton({ record = {} }) {
  return (
    <FlatButton
      primary
      label="Edit"
      icon={<ContentCreate />}
      containerElement={<Link to={linkToRecordByReplaceId(dualScreenAdEditFrontendPath, record.id)} />}
      style={{ overflow: "inherit" }}
    ></FlatButton>
  );
}

function ViewButton({ record = {} }) {
  return (
    <FlatButton
      primary
      label="View"
      icon={<ContentCreate />}
      containerElement={<Link to={linkToRecordByReplaceId(dualScreenAdDetailFrontendPath, record.id)} />}
      style={{ overflow: "inherit" }}
    ></FlatButton>
  );
}

const TimePeriod = function ({ record = {} }) {
  const newSourceName = "time_period";
  const showRecord = {
    ...record,
    [newSourceName]: record.valid_from + '-' + record.valid_to
  }
  return <TextField source={newSourceName} label="VALID PERIOD" record={showRecord} />
}

const DualScreenAdList = (props) => {
  const {initialValues = {}} = props;
  return (
    <List {...props} autoLoadData={true} hasCreate={true} filters={<ListFilter defaultSearchValue={initialValues} />}>
      <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
        <TextField source="id" label="ID" />
        <ChoiceDisplayField source="ad_type" label="TYPE" choiceName={DualScreenAdTypeMap} />
        <TextField source="ad_name" label="NAME" />
        <ChoiceDisplayField source="target_type" label="TARGET USERS" choiceName={DualScreenAdTargetUsersMap} />
        <TextField source="priority" label="PRIORITY" />
        <TimePeriod source={""} label="VALID PERIOD" />
        <TextField source="created_at" label="CREATE TIME" />
        <TextField source="updated_at" label="LAST UPDATED DATE" />
        <TextField source="last_updated_by" label="LAST UPDATED BY" />
        <TextField source="publish_status" label="PUBLISH STATUS" />
        <ChoiceDisplayField source="ad_status" label="STATUS" choiceName={DualScreenAdStatusMap} />
        <EditButton label="Edit" width="100" />
        <ViewButton label="View" />
      </Datagrid>
    </List>
  );
}



export default connect(
  state => ({
    initialValues: state.admin.filter[DualScreenAdResourceName],
  })
)(DualScreenAdList);

// export default DualScreenAdList




// WEBPACK FOOTER //
// ./src/routes/advancedFunction/DualScreenAdList.js